import { external as externalScriptLoader } from '../../utils/script'
import { externalScriptsConfig } from '../config/externalScripts'
export function initGtm() {
  externalScriptLoader.load({
    name: externalScriptsConfig.gtmAnalytics.name,
    loadNow: true,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/gtmScriptInitializer.js